<template>
	<section class="section-card">
		<div class="section-head">
			<div class="section-head__left">
				<h2 class="section-title">一、设备画像概览</h2>
			</div>
			<span class="section-time">最近分析时间：{{ data.analyzeTime }}</span>
		</div>

		<div class="overview-body">
			<div class="status-card" :class="data.status">
				<div class="status-card__header">
					<span class="status-badge" :class="data.status">{{ statusLabel }}</span>
					<span class="status-device">{{ data.deviceNo }}</span>
				</div>
				<div class="status-card__fields">
					<div class="status-field">
						<span class="status-field__label">统计日期</span>
						<span class="status-field__value">{{ data.statDate }}</span>
					</div>
					<el-divider />
					<div class="status-field">
						<span class="status-field__label">隐患类型</span>
						<span class="status-field__value">{{ data.anomalyType }}</span>
					</div>
					<el-divider />
					<div class="status-field">
						<span class="status-field__label">集群距离</span>
						<span class="status-field__value">{{ data.clusterDistance }}</span>
					</div>
				</div>
			</div>

			<div class="indicator-groups">
				<div class="indicator-group" v-for="group in indicatorGroups" :key="group.key" :class="group.status">
					<div class="indicator-group__header">
						<span class="indicator-group__badge" :class="group.status">{{ group.statusLabel }}</span>
						<span class="indicator-group__title">{{ group.title }}</span>
					</div>
					<div class="indicator-list">
						<div class="indicator-item" v-for="item in group.items" :key="item.key">
							<div class="indicator-item__top">
								<span class="indicator-item__label">{{ item.label }}</span>
							</div>
							<div class="indicator-item__bottom">
								<span class="indicator-item__value">
									{{ item.value }}
									<small v-if="item.unit">{{ item.unit }}</small>
								</span>
								<span class="indicator-item__deviation" :class="item.direction">
									<i v-if="item.direction === 'up'" class="el-icon-top"></i>
									<i v-else-if="item.direction === 'down'" class="el-icon-bottom"></i>
									{{ formatDeviation(item.deviation) }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'OverviewSection',
	props: {
		profileData: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		data() {
			return this.profileData || {}
		},
		statusLabel() {
			return this.data.status === 'abnormal' ? '异常' : '正常'
		},
		indicatorGroups() {
			const groups = [
				{ key: 'pressure', title: '压力指标', data: this.data.pressure },
				{ key: 'flow', title: '流量指标', data: this.data.flow },
				{ key: 'temperature', title: '温度指标', data: this.data.temperature },
			]
			return groups
				.filter(g => g.data)
				.map(g => ({
					...g,
					status: g.data.status || 'normal',
					statusLabel: g.data.status === 'abnormal' ? '异常' : '正常',
					items: g.data.items || [],
				}))
		},
	},
	methods: {
		formatDeviation(value) {
			if (value === null || value === undefined || value === 0) return '--'
			const prefix = value > 0 ? '↑' : '↓'
			return `${prefix} 偏差 ${Math.abs(value).toFixed(2)}σ`
		},
	},
}
</script>

<style lang="scss" scoped>
.section-card {
	position: relative;
	padding: 22px 24px 18px;
	background: var(--panel-bg);
	border: 1px solid var(--panel-border);
	border-radius: 12px;
	box-shadow: var(--panel-shadow);
	backdrop-filter: blur(12px);
}

.section-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 18px;
}

.section-title {
	margin: 0;
	color: var(--title);
	font-size: 17px;
	font-weight: 700;
	letter-spacing: 0.01em;
}

.section-time {
	font-size: 13px;
	color: var(--muted);
	flex-shrink: 0;
}

.overview-body {
	display: flex;
	gap: 16px;
}

.status-card {
	width: 260px;
	flex-shrink: 0;
	border-radius: 10px;
	padding: 18px;
	border: 1px solid var(--line);
	background: #fff;

	&.abnormal {
		border-color: #fecaca;
		background: #fff5f5;
	}

	::v-deep .el-divider {
		margin: 10px 0;
	}
}

.status-card__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
}

.status-badge {
	display: inline-flex;
	align-items: center;
	font-size: 13px;
	font-weight: 600;
	padding: 3px 10px;
	border-radius: 10px;

	&.normal {
		color: #16a34a;
		background: #dcfce7;
	}
	&.abnormal {
		color: #dc2626;
		background: #fee2e2;
	}
}

.status-device {
	font-size: 14px;
	font-weight: 600;
	color: var(--title);
}

.status-field {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
}

.status-field__label {
	font-size: 13px;
	color: var(--muted);
	flex-shrink: 0;
}

.status-field__value {
	font-size: 13px;
	color: var(--text);
	text-align: right;
	word-break: break-all;
}

.indicator-groups {
	flex: 1;
	min-width: 0;
	display: flex;
	gap: 16px;
}

.indicator-group {
	flex: 1;
	min-width: 0;
	border-radius: 10px;
	border: 1px solid var(--line);
	padding: 16px;
	background: #fff;

	&.abnormal {
		border-color: #fecaca;
	}
}

.indicator-group__header {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 14px;
	padding-bottom: 10px;
	border-bottom: 1px solid var(--line);
}

.indicator-group__badge {
	display: inline-flex;
	align-items: center;
	font-size: 12px;
	font-weight: 600;
	padding: 2px 8px;
	border-radius: 8px;

	&.normal {
		color: #16a34a;
		background: #dcfce7;
	}
	&.abnormal {
		color: #dc2626;
		background: #fee2e2;
	}
}

.indicator-group__title {
	font-size: 15px;
	font-weight: 600;
	color: var(--title);
}

.indicator-list {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.indicator-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.indicator-item__label {
	font-size: 13px;
	color: var(--muted);
}

.indicator-item__bottom {
	display: flex;
	align-items: center;
	gap: 8px;
}

.indicator-item__value {
	font-size: 15px;
	font-weight: 700;
	color: var(--title);

	small {
		font-size: 12px;
		font-weight: 400;
		color: var(--muted);
		margin-left: 1px;
	}
}

.indicator-item__deviation {
	font-size: 12px;
	display: flex;
	align-items: center;
	gap: 2px;

	&.up {
		color: #dc2626;
	}
	&.down {
		color: #2563eb;
	}
	&[class=''] {
		color: var(--muted);
	}

	i {
		font-size: 12px;
	}
}

@media (max-width: 1240px) {
	.overview-body {
		flex-direction: column;
	}
	.status-card {
		width: 100%;
	}
	.indicator-groups {
		flex-direction: column;
	}
}

@media (max-width: 900px) {
	.indicator-item {
		flex-direction: column;
		align-items: flex-start;
		gap: 4px;
	}
}
</style>
